import { gql } from '@apollo/client';

// Simplified subscription without complex filters - just listen to all Notification changes
export const NOTIFICATION_SUBSCRIPTION_SIMPLE = gql`
  subscription NOTIFICATION_SUBSCRIPTION_SIMPLE {
    Notification(filter: {
      mutation_in: [create, update]
    }) {
      mutation
      node {
        id
        title
        description
        status
        mode
        relatedEntityUrl
        createdAt
        userId {
          id
        }
        templateId {
          id
          name
          isActive
        }
      }
    }
  }
`;


